
<template>
    <div id="app">
        <a-config-provider :locale="locale">
            <router-view />
        </a-config-provider>
    </div>
</template>




<script>
import { mapMutations } from "vuex";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
    data() {
        return {
            locale: zhCN
        };
    },
    mounted() {
        const token = localStorage.getItem("token");
        const userinfo = localStorage.getItem("userinfo");
        if (userinfo) {
            this.changeState({
                name: "userinfo",
                value: userinfo
            });
        }
        if (token) {
            this.loadCurrentCampus();
        }
    },
    methods: {
        async loadCurrentCampus() {
            const res = await this.$axios.post('/api/admin/getmorenorg');
            this.changeState({
                name: 'campusInfo',
                value: res.data
            });
        },
        ...mapMutations(["changeState"]),
    },
};
</script>
<style>
@import './styles/custom.css';
</style>

